export const AdvancedUserIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="103"
      height="108"
      viewBox="0 0 103 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_226_688)">
        <rect
          x="0.580078"
          y="0.398438"
          width="102.029"
          height="107.047"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M63.0712 35.1394C62.6927 31.0706 60.8002 28.1373 56.9206 26.5287C55.2174 25.7717 53.4195 25.4878 51.6217 25.4878C49.8238 25.4878 48.026 25.7717 46.3228 26.5287C42.4432 28.1373 40.5507 31.0706 40.1722 35.1394C40.0776 35.7072 40.1722 36.3695 40.1722 36.9373C40.1722 41.1007 41.1185 45.1695 42.8217 49.0491C43.6733 50.9416 44.9034 52.6448 46.3228 54.0641C47.8367 55.5781 49.7292 56.3351 51.6217 56.2405C53.5142 56.3351 55.4066 55.5781 56.9206 54.0641C58.34 52.5502 59.5701 50.9416 60.4217 49.0491C62.0303 45.1695 63.0712 41.1953 63.0712 36.9373V35.1394ZM79.0626 76.2061C78.9679 73.1781 78.7787 70.1502 77.8325 67.2168C77.5486 66.3652 77.2647 65.5136 76.697 64.8512C76.1292 64.1889 75.3722 63.4319 74.5206 63.2426C72.5335 62.6749 70.5464 62.2018 68.5593 61.7287C65.5314 60.9717 62.5034 60.2147 59.5701 59.4577C59.3808 59.4577 59.1916 59.4577 58.9077 59.3631C58.9077 59.4577 58.8131 59.6469 58.8131 59.7416C58.2453 61.634 57.7722 63.6211 57.2045 65.5136L54.9335 72.3265C54.8389 72.6104 54.7443 72.7996 54.555 73.0835C54.4604 72.0426 54.2712 70.7179 54.0819 69.3932C53.798 66.933 53.4195 64.4728 53.4195 64.3781C53.5142 64.0943 53.7034 63.8104 53.798 63.5265C53.798 63.5265 53.798 63.4319 53.8927 63.4319C53.9873 63.2426 53.9873 63.148 54.0819 62.9588C54.0819 62.8642 54.1765 62.8642 54.1765 62.7695C54.2712 62.5803 54.3658 62.2964 54.3658 62.1072C54.3658 61.9179 54.2712 61.634 54.1765 61.5394V61.4448V61.3502C54.1765 61.2556 54.0819 61.2556 54.0819 61.1609V61.0663C54.0819 60.9717 53.9873 60.9717 53.8927 60.8771C53.798 60.7824 53.7034 60.7824 53.6088 60.7824H49.6346C49.54 60.7824 49.3507 60.8771 49.2561 61.0663V61.1609C49.1615 61.2556 49.0668 61.5394 49.0668 61.7287C49.0668 61.8233 48.9722 61.9179 48.9722 62.1072C48.9722 62.391 49.0668 62.5803 49.1615 62.7695V62.8642L49.2561 62.9588C49.3507 63.148 49.4453 63.2426 49.4453 63.4319V63.5265C49.54 63.8104 49.7292 64.0943 49.8238 64.3781C49.8238 64.4728 49.7292 64.9459 49.6346 65.7975C49.3507 67.69 48.9722 71.0018 48.6884 73.0835C48.5937 72.7996 48.4045 72.6104 48.3099 72.3265C47.5529 70.0555 46.7013 67.7846 46.0389 65.5136C45.4711 63.6211 44.998 61.634 44.4303 59.7416C44.4303 59.6469 44.3357 59.4577 44.3357 59.3631C44.0518 59.3631 43.8625 59.3631 43.6733 59.4577C41.0238 60.1201 38.2797 60.7824 35.6303 61.4448C33.3593 62.0125 30.9937 62.5803 28.7228 63.2426C27.9658 63.4319 27.2088 64.0943 26.641 64.7566L26.5464 64.8512C25.9787 65.5136 25.6948 66.3652 25.4109 67.2168C24.5593 69.7717 24.3701 72.5158 24.1808 75.1652V76.2061C24.0862 78.0986 23.8023 77.7201 25.6948 78.5717L27.1142 79.1394C30.5206 80.2749 33.9271 80.9373 37.4281 81.4104C40.8346 81.8835 44.241 82.1674 47.7421 82.262C48.4045 82.262 53.7034 82.3566 53.7034 82.3566C54.3658 82.3566 55.0281 82.3566 55.6905 82.262C61.0841 82.0728 66.5722 81.5996 71.8712 80.3695C73.3851 79.991 74.8045 79.6125 76.3185 79.1394C76.7916 78.9502 77.2647 78.8556 77.7378 78.5717C79.3464 77.7201 79.0626 78.0986 79.0626 76.2061Z"
          fill="#F9FAFD"
        />
        <rect
          x="0.998231"
          y="0.816591"
          width="101.193"
          height="106.211"
          rx="12.1264"
          stroke="url(#paint0_linear_226_688)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_226_688"
          x="-21.1639"
          y="-21.3455"
          width="145.517"
          height="150.535"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_226_688"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_226_688"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_226_688"
          x1="9.71204"
          y1="0.398437"
          x2="58.4874"
          y2="63.1307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
